import _ from "lodash";
import BaseApiModel from "scripts/models/baseApiModel";
import NotFoundSyncError from "scripts/exceptions/notFoundSyncError";

import thumbnailFallbackUrl from "images/fallbacks/fallback_380_380.png";
import fallBackImage from "images/fallbacks/fallback_160_160.png";

class ModulePreviewModel extends BaseApiModel {
  urlRoot() {
    return `${this.apiUrlRoot}/creator/modules`;
  }

  url() {
    return this.urlRoot();
  }

  parse(response) {
    if (_.isEmpty(response)) {
      throw new NotFoundSyncError(["No module available for preview for this org"]);
    }

    response = response[0];

    // TODO: need proper image for this model
    // Add module icon fallback image
    response.iconFallbackUrl = fallBackImage;
    response.thumbnailFallbackUrl = thumbnailFallbackUrl;

    response.whiteMediaBadges = _.filter(response.mediaBadges, {
      type: "white",
    });
    response.blackMediaBadges = _.filter(response.mediaBadges, {
      type: "black",
    });

    return response;
  }
}

export default ModulePreviewModel;
